import React from 'react'
import s from '../components/news/NewsBanner.module.scss'
import classNames from 'classnames'

interface Props {
    views: number
    saves?: number
    likes?: number
    color?: string
    isLiked?: boolean
    toggleLike?: (val: boolean) => void
    lightTheme?: boolean
}

const Stats: React.FC<Props> = ({ views, saves, likes, color, isLiked, toggleLike, lightTheme }) => {
    return (
        <div className='stats'>
            <div>
                <svg
                    width='22'
                    height='20'
                    viewBox='0 0 22 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M11 17C14.6823 17 18.0156 14.8326 21 10.5C18.0146 6.16736 14.6823 4 11 4C7.31769 4 3.98435 6.16632 1 10.5C3.98538 14.8326 7.31769 17 11 17Z'
                        stroke={color ? color : '#C1CCE2'}
                        strokeWidth='1.6'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className={lightTheme ? s.icoColor : ''}
                    />
                    <circle
                        cx='11'
                        cy='10'
                        r='3.2'
                        stroke={color ? color : '#C1CCE2'}
                        strokeWidth='1.6'
                        className={lightTheme ? s.icoColor : ''}
                    />
                </svg>
                <p className={lightTheme ? s.dateColor : ''}>{views}</p>
            </div>
            {saves && (
                <div>
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M4 5.06897C4 4.52024 4.24082 3.99399 4.66947 3.60599C5.09812 3.21798 5.67951 3 6.28571 3H13.7143C14.3205 3 14.9019 3.21798 15.3305 3.60599C15.7592 3.99399 16 4.52024 16 5.06897V18L10 13.3448L4 18V5.06897Z'
                            stroke={color ? color : '#C1CCE2'}
                            strokeWidth='1.6'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            className={lightTheme ? s.icoColor : ''}
                        />
                    </svg>
                    <p className={lightTheme ? s.dateColor : ''}>{saves}</p>
                </div>
            )}
            {(likes === 0 || likes > 0) && (
                <div
                    className={toggleLike ? 'stats__like' : ''}
                    onClick={() => toggleLike && toggleLike(!isLiked)}
                >
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill={isLiked ? '#A9B4D1' : 'none'}
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M2.75 10.25L10 17.5L17.25 10.25C18.7688 8.73122 18.7688 6.26878 17.25 4.75C15.7312 3.23122 13.2688 3.23122 11.75 4.75L10 6.5L8.25 4.75C6.73122 3.23122 4.26878 3.23122 2.75 4.75C1.23122 6.26878 1.23121 8.73121 2.75 10.25Z'
                            stroke={isLiked ? '#A9B4D1' : color ? color : '#C1CCE2'}
                            strokeWidth='1.6'
                            className={lightTheme ? s.icoColor : ''}
                        />
                    </svg>
                    <p className={lightTheme ? s.dateColor : ''}>{likes}</p>
                </div>
            )}
        </div>
    )
}

export default Stats
